<script setup lang="ts">
import { ConfirmModal } from '@collector/shared-ui'
</script>

<template>
  <ConfirmModal>
    <template #title>Would you like to reset the match?</template>
    <div>
      All progress (results, stats, incidents etc.) in this event will be lost
    </div>
  </ConfirmModal>
</template>
